import React from "react";
import { withRouter } from "react-router-dom";
import withFirebase from "../hoc/withFirebase";
import { Route } from "react-router-dom";
import withUser from "../hoc/withUser";
import SingleDealDetails from "../components/SingleDealDetails";
import AddDealPayment from "../components/AddDealPayment";
import AddDealDispatch from "../components/AddDealDispatch";
import Deals from "../components/Deals";
import AddDeals from "../components/AddDeals";
import SaudaChittiContainer from "../containers/SaudaChitti";
class DealsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeDeals: [],
      closedDeals: [],
      payments: [],
      deals: [],
      dispatches: [],
      isLoadingPayment: true,
      isLoadingDispatches: true,
      isLoading: true,
      customers: [],
      units: [],
      products: [],
      transporters: [],
      organisations: [],
      bardanaCondition: [],
      dealQuality: [],
      dispatchCondition: [],
      invoicePrintData: []
    };
  }
  componentWillMount() {
    this.props.db
      .collection("deals")
      .orderBy("createdAt", "desc")
      .onSnapshot(querySnapshot => {
        const deals = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singleDeal = doc.data();
            singleDeal.id = doc.id;
            deals.push(singleDeal);
          }
        });
        this.setState({ deals, isLoading: false });
      });
    this.props.db
      .collection("invoicePrintData")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const invoicePrintData = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const invData = doc.data();
            invData.id = doc.id;
            invoicePrintData.push(invData);
          }
        });
        this.setState({ invoicePrintData, isLoading: false });
      });
    this.fetchActiveDeals();
    this.fetchClosedDeals();
    this.fetchPayments();
    this.fetchDispatches();
    this.fetchProducts();
    this.fetchUnits();
    this.fetchCustomers();
    this.fetchTransporters();
    this.fetchOrganisations();
    this.fetchBardanaCondition();
    this.fetchdealQuality();
    this.fetchDispatchCondition();
    // this.fetchInvoicePrintData();
  }
  fetchPayments = () => {
    this.props.db
      .collection("payments")
      .orderBy("createdAt", "desc")
      .onSnapshot(querySnapshot => {
        const payments = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singlePayment = doc.data();
            singlePayment.id = doc.id;
            payments.push(singlePayment);
          }
        });
        this.setState({ payments, isLoadingPayment: false }, () => {
          console.log(1);
        });
      });
  };
  fetchBardanaCondition = () => {
    this.props.db
      .collection("bardanaCondition")
      .where("userId", "==", this.props.user.uid)
      .orderBy("createdAt", "desc")
      .onSnapshot(querySnapshot => {
        const bardanaCondition = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singleBardanaCondition = doc.data();
            singleBardanaCondition.id = doc.id;
            bardanaCondition.push(singleBardanaCondition);
          }
        });
        this.setState({ bardanaCondition, isLoadingPayment: false });
      });
  };
  fetchdealQuality = () => {
    this.props.db
      .collection("dealQuality")
      .where("userId", "==", this.props.user.uid)
      .orderBy("createdAt", "desc")
      .onSnapshot(querySnapshot => {
        const dealQuality = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singleDealQuality = doc.data();
            singleDealQuality.id = doc.id;
            dealQuality.push(singleDealQuality);
          }
        });
        this.setState({ dealQuality, isLoadingPayment: false });
      });
  };
  fetchDispatchCondition = () => {
    this.props.db
      .collection("dispatchCondition")
      .where("userId", "==", this.props.user.uid)
      .orderBy("createdAt", "desc")
      .onSnapshot(querySnapshot => {
        const dispatchCondition = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singleDispatchCondition = doc.data();
            singleDispatchCondition.id = doc.id;
            dispatchCondition.push(singleDispatchCondition);
          }
        });
        this.setState({ dispatchCondition, isLoadingPayment: false });
      });
  };
  fetchDispatches = () => {
    this.props.db
      .collection("dispatches")
      .orderBy("createdAt", "desc")
      .onSnapshot(querySnapshot => {
        const dispatches = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singleDispatch = doc.data();
            singleDispatch.id = doc.id;
            dispatches.push(singleDispatch);
          }
        });
        this.setState({ dispatches, isLoadingDispatches: false }, () => {
          console.log(1);
        });
      });
  };
  fetchActiveDeals = () => {
    this.props.db
      .collection("deals")
      .where("userId", "==", this.props.user.uid)
      .where("activeStatus", "==", true)
      .orderBy("createdAt", "desc")
      .onSnapshot(querySnapshot => {
        const activeDeals = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singleDeal = doc.data();
            singleDeal.id = doc.id;
            activeDeals.push(singleDeal);
          }
        });
        this.setState({ activeDeals, isLoading: false }, () => {
          console.log(1);
        });
      });
  };
  fetchClosedDeals = () => {
    this.props.db
      .collection("deals")
      .where("userId", "==", this.props.user.uid)
      .where("activeStatus", "==", false)
      .orderBy("createdAt", "desc")
      .onSnapshot(querySnapshot => {
        const closedDeals = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singleDeal = doc.data();
            singleDeal.id = doc.id;
            closedDeals.push(singleDeal);
          }
        });
        this.setState({ closedDeals, isLoading: false }, () => {
          console.log(1);
        });
      });
  };
  fetchCustomers = () => {
    this.props.db
      .collection("customers")
      .where("userId", "==", this.props.user.uid)
      .orderBy("createdAt", "desc")
      .onSnapshot(querySnapshot => {
        const customers = [];
        querySnapshot.forEach(doc => {
          const singleCustomer = doc.data();
          singleCustomer.id = doc.id;
          customers.push(singleCustomer);
        });
        this.setState({ customers: customers, isLoading: false });
      });
  };
  // fetchInvoicePrintData = () => {
  //   this.props.db
  //     .collection("invoicePrintData")
  //     .where("userId", "==", this.props.user.uid)
  //     .onSnapshot(querySnapshot => {
  //       const invoicePrintData = [];
  //       querySnapshot.forEach(doc => {
  //         if (doc.exists) {
  //           const invData = doc.data();
  //           invData.id = doc.id;
  //           invoicePrintData.push(invData);
  //         }
  //       });
  //       this.setState({ invoicePrintData, isLoading: false });
  //     });
  // };
  addCustomer = (
    name,
    email,
    phoneNumber,
    address,
    gstNumber,
    panNumber,
    tinNumber
  ) => {
    return this.props.db.collection("customers").add({
      name: name,
      email: email,
      phoneNumber: phoneNumber,
      address: address,
      panNumber: panNumber,
      gstNumber: gstNumber,
      tinNumber: tinNumber,
      isActive: true,
      imageURL: "",
      userId: this.props.user.uid,
      createdAt: new Date(),
      createdBy: this.props.user.uid
    });
  };
  fetchUnits = () => {
    this.props.db
      .collection("units")
      .where("userId", "==", this.props.user.uid)
      .orderBy("createdAt", "desc")
      .onSnapshot(querySnapshot => {
        const units = [];
        querySnapshot.forEach(doc => {
          const singleUnit = doc.data();
          singleUnit.id = doc.id;
          units.push(singleUnit);
        });
        this.setState({ units, isLoading: false });
      });
  };

  fetchProducts = () => {
    this.props.db
      .collection("products")
      .where("userId", "==", this.props.user.uid)
      .orderBy("createdAt", "desc")
      .onSnapshot(querySnapshot => {
        const products = [];
        querySnapshot.forEach(doc => {
          const singleProduct = doc.data();
          singleProduct.id = doc.id;
          products.push(singleProduct);
        });
        this.setState({ products, isLoading: false });
      });
  };
  fetchTransporters = () => {
    this.props.db
      .collection("transporters")
      .where("userId", "==", this.props.user.uid)
      .orderBy("createdAt", "desc")
      .onSnapshot(querySnapshot => {
        const transporters = [];
        querySnapshot.forEach(doc => {
          const singleTransporter = doc.data();
          singleTransporter.id = doc.id;
          transporters.push(singleTransporter);
        });
        this.setState({ transporters, isLoading: false });
      });
  };
  fetchOrganisations = () => {
    this.props.db
      .collection("organisations")
      .where("createdBy", "==", this.props.user.uid)
      .orderBy("createdAt", "desc")
      .onSnapshot(querySnapshot => {
        const organisations = [];
        querySnapshot.forEach(doc => {
          const singleOrganisation = doc.data();
          singleOrganisation.organisationId = doc.id;
          organisations.push(singleOrganisation);
        });
        this.setState({ organisations, isLoading: false });
      });
  };
  addDeal = async (
    sellerName,
    sellerId,
    buyerId,
    buyerName,
    products,
    quantity,
    gstCondition,
    typeOfRate,
    rate,
    activeStatus,
    date,
    userId,
    buyerBrokerage,
    sellerBrokerage,
    pendingAmount,
    paidAmount,
    pendingDelivered,
    unit,
    paidDelivered,
    description,
    isDealPaymentComplete,
    isDealDeliveryComplete,
    organisationId,
    truckTrollaQuantity,
    truckTrollaName,
    createdAt,
    sellerThrough,
    buyerThrough,
    dispatchCondition,
    quality,
    bardanaCondition
  ) => {
    let organisation = this.props.db
      .collection("organisations")
      .doc(organisationId);
    let newDealId = this.props.db.collection("deals").doc().id;
    let newDeal = this.props.db.collection("deals").doc(newDealId);
    let buyerMiddleMan = this.props.db
      .collection("customerDeals")
      .doc(buyerId + "_" + newDealId);
    let sellerMiddleMan = this.props.db
      .collection("customerDeals")
      .doc(sellerId + "_" + newDealId);
    await this.props.db
      .runTransaction(async transaction => {
        const customerOrganisation = await transaction.get(organisation);
        const nDeal = await transaction.get(newDeal);
        const buyerMidMan = await transaction.get(buyerMiddleMan);
        const sellerMidMan = await transaction.get(sellerMiddleMan);
        const currentSerialNumber = customerOrganisation.exists
          ? customerOrganisation.data().serialNumber + 1
          : 1;
        await transaction.set(newDeal, {
          sellerName: sellerName,
          sellerId: sellerId,
          buyerId: buyerId,
          buyerName: buyerName,
          products: products,
          quantity: quantity,
          gstCondition: gstCondition,
          typeOfRate: typeOfRate,
          rate: rate,
          activeStatus: activeStatus,
          date: date,
          userId: userId,
          buyerBrokerage: buyerBrokerage,
          sellerBrokerage: sellerBrokerage,
          pendingAmount: pendingAmount,
          paidAmount: paidAmount,
          pendingDelivered: pendingDelivered,
          unit: unit,
          paidDelivered: paidDelivered,
          description: description,
          isDealPaymentComplete: isDealPaymentComplete,
          isDealDeliveryComplete: isDealDeliveryComplete,
          organisationId: organisationId,
          truckTrollaQuantity: truckTrollaQuantity,
          truckTrollaName: truckTrollaName,
          createdAt: createdAt,
          sellerThrough: sellerThrough,
          buyerThrough: buyerThrough,
          dispatchCondition: dispatchCondition,
          quality: quality,
          bardanaCondition: bardanaCondition,
          serialNumber: currentSerialNumber
        });
        await transaction.set(buyerMiddleMan, {
          customerId: buyerId,
          dealId: newDealId,
          userId: userId,
          isInvoiceCreated: false,
          isInvoicePaid: false,
          organisationId: organisationId,
          createdAt: new Date()
        });
        await transaction.set(sellerMiddleMan, {
          customerId: sellerId,
          dealId: newDealId,
          userId: userId,
          isInvoiceCreated: false,
          isInvoicePaid: false,
          organisationId: organisationId,
          createdAt: new Date()
        });
        await transaction.update(organisation, {
          serialNumber: currentSerialNumber
        });
        return Promise.resolve("Deal and Middleman Created");
      })
      .then(result => {
        this.setState({ isLoading: false }, () => {
          console.log(1);
          this.props.history.push("/deal");
          console.log("Transaction success", result);
        });
      })
      .catch(err => {
        this.setState({ isLoading: false }, () => {
          console.log(1);
          console.log("Transaction failure:", err);
        });
      });
    // }
  };
  handleCreateDialogEntry = (entryData, entryFor) => {
    if (entryFor === "addNewProduct") {
      return this.props.db.collection("products").add(entryData);
    } else if (entryFor === "addNewUnit") {
      return this.props.db.collection("units").add(entryData);
    } else if (entryFor === "addDealQuality") {
      return this.props.db.collection("dealQuality").add(entryData);
    } else if (entryFor === "addBardanaCondition") {
      return this.props.db.collection("bardanaCondition").add(entryData);
    } else if (entryFor === "addDispatchCondition") {
      return this.props.db.collection("dispatchCondition").add(entryData);
    } else if (entryFor === "addTransporter") {
      return this.props.db.collection("transporters").add(entryData);
    } else {
      console.log("Invalid operation");
    }
  };
  handlePaymentDeliveryCheckbox = (type, checkBoxStatus, dealId) => {
    if (type === "paymentComplete") {
      this.props.db
        .collection("deals")
        .doc(dealId)
        .update({
          isDealPaymentComplete: checkBoxStatus
        });
    } else if (type === "deliveryComplete") {
      this.props.db
        .collection("deals")
        .doc(dealId)
        .update({
          isDealDeliveryComplete: checkBoxStatus
        });
    }
  };
  fetchDealDetails = dealId => {
    console.log(dealId);
    this.fetchInvoicePrintData();
  };
  addDealPayment = dealPayment => {
    this.props.db.collection("payments").add(dealPayment);
  };
  updateSingleDealPaymentHistory = (id, pendingAmount, paidAmount) => {
    this.props.db
      .collection("deals")
      .doc(id)
      .update({
        pendingAmount: pendingAmount,
        paidAmount: paidAmount
      });
  };

  updateSingleDealDispatchHistory = (id, pendingDispatch, paidDispatch) => {
    this.props.db
      .collection("deals")
      .doc(id)
      .update({
        pendingDelivered: pendingDispatch,
        paidDelivered: paidDispatch
      });
  };
  updateDealStatus = (status, id) => {
    this.props.db
      .collection("deals")
      .doc(id)
      .update({
        activeStatus: !status
      });
  };
  addDealDispatch = dispatch => {
    this.props.db.collection("dispatches").add(dispatch);
  };
  // handleBardanaDispatchAdd = (bardanaDispatchName, type, organisationId) => {
  //   type === "addBardanaCondition"
  //     ? this.props.db
  //         .collection("bardanaCondition")
  //         .add({
  //           name: bardanaDispatchName,
  //           createdAt: new Date(),
  //           userId: this.props.user.uid,
  //           organisationId: organisationId
  //         })
  //         .then(this.fetchBardanaCondition())
  //     : this.props.db
  //         .collection("dispatchCondition")
  //         .add({
  //           name: bardanaDispatchName,
  //           createdAt: new Date(),
  //           userId: this.props.user.uid,
  //           organisationId: organisationId
  //         })
  //         .then(this.fetchDispatchCondition());
  // };
  render() {
    const { user } = this.props;
    const {
      closedDeals,
      activeDeals,
      deals,
      isLoadingPayment,
      payments,
      dispatches,
      customers,
      products,
      units,
      transporters,
      organisations,
      bardanaCondition,
      dealQuality,
      isLoading,
      dispatchCondition,
      invoicePrintData
    } = this.state;
    const transactions = this.state.dispatches.concat(this.state.payments);
    return (
      <div>
        <Route
          exact
          path="/deals"
          render={props => (
            <Deals
              {...props}
              user={user}
              allDeals={activeDeals.concat(closedDeals)}
              invoicePrintData={invoicePrintData.find(
                invData => invData.userId === this.props.user.uid
              )}
              activeDeals={activeDeals}
              closedDeals={closedDeals}
              payments={payments && payments}
              dispatches={dispatches && dispatches}
              fetchDealDetails={this.fetchDealDetails}
              isLoadingPayment={isLoadingPayment}
              transactions={transactions}
              organisations={organisations}
            />
          )}
        />
        <Route
          exact
          path="/deals/addDeal"
          render={props => (
            <AddDeals
              {...props}
              addDeal={this.addDeal}
              user={user}
              customers={customers}
              organisations={organisations.find(
                org => org.createdBy === this.props.user.uid
              )}
              newCustomer={this.state.newCustomer}
              buyerCustomers={customers}
              sellerCustomers={customers}
              products={products}
              units={units}
              addCustomer={this.addCustomer}
              bardanaCondition={bardanaCondition}
              isLoading={isLoading}
              dealQuality={dealQuality}
              dispatchCondition={dispatchCondition}
              handleBardanaDispatchAdd={this.handleBardanaDispatchAdd}
              handleCreateDialogEntry={this.handleCreateDialogEntry}
            />
          )}
        />
        <Route
          exact
          path="/deals/:dealId/addDealPayment"
          render={props => (
            <AddDealPayment
              {...props}
              addDealPayment={this.addDealPayment}
              deals={deals}
              updateSingleDealPaymentHistory={
                this.updateSingleDealPaymentHistory
              }
              organisations={organisations.find(
                org => org.createdBy === this.props.user.uid
              )}
            />
          )}
        />
        <Route
          exact
          path="/deals/:dealId/addDealDispatch"
          render={props => (
            <AddDealDispatch
              {...props}
              addDealDispatch={this.addDealDispatch}
              deals={deals}
              user={user}
              transporters={transporters}
              updateSingleDealDispatchHistory={
                this.updateSingleDealDispatchHistory
              }
              organisations={organisations.find(
                org => org.createdBy === this.props.user.uid
              )}
              handleCreateDialogEntry={this.handleCreateDialogEntry}
            />
          )}
        />

        <Route
          path="/deals/singleDealDetails/:dealId"
          render={props => (
            <SingleDealDetails
              {...props}
              deals={deals}
              addDealDispatch={this.addDealDispatch}
              payments={payments}
              updateDealStatus={this.updateDealStatus}
              dispatches={dispatches}
              addDealPayment={this.addDealPayment}
              handlePaymentDeliveryCheckbox={this.handlePaymentDeliveryCheckbox}
              organisations={organisations.find(
                org => org.createdBy === this.props.user.uid
              )}
            />
          )}
        />
        <Route
          path="/deals/saudaChitti/:dealId"
          render={props => (
            <SaudaChittiContainer
              {...props}
              deals={deals}
              addDealDispatch={this.addDealDispatch}
              payments={payments}
              updateDealStatus={this.updateDealStatus}
              dispatches={dispatches}
              addDealPayment={this.addDealPayment}
              handlePaymentDeliveryCheckbox={this.handlePaymentDeliveryCheckbox}
              organisations={organisations.find(
                org => org.createdBy === this.props.user.uid
              )}
            />
          )}
        />
      </div>
    );
  }
}

export default withRouter(withUser(withFirebase(DealsContainer)));
